<template>
  <div class="swiper-box">
    <div class="nav-btn btn-prev" slot="button-prev" @click="goToPrev">
      <img :src="navImg[0]" alt="">
    </div>
    <swiper ref="leftSlide" :options="swiperOptions" :key="swiperKey">
      <swiper-slide v-for="(item, idx) in swiperImages" :key="idx" :style="isMobile ? {width: '2rem'} : {}">
        <img :src="item" alt="" width="100%" height="auto" class="swiper-img" />
      </swiper-slide>
    </swiper>
    <div class=" nav-btn btn-next" slot="button-next" @click="goToNext">
      <img :src="navImg[1]" alt="">
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { isMobile } from '../../utils/tools';
export default {
  name: "InviteSwiper",
  components: { swiper, swiperSlide },
  props: {
    navigator: {
      type: Boolean,
      default: false
    },
    swiperImages: {
      type: Array
    },
    navImg: {
      type: Array
    },
    slidesPerView: {
      type: Number,
      default: 1,
    }
  },
  computed: {
    swiperOptions() {
      return {
        speed: 1000,
        loop: true,
        slidesPerView: this.slidesPerView,
        autoplay: {
          disableOnInteraction: false,
          delay: 3000
        },
        navigation: {
          nextEl: ".next-btn",
          prevEl: ".prev-btn"
        }
      }
    }
  },
  watch: {
    slidesPerView(newVal) {
      console.log(newVal);
    }
  },
  mounted() {
    console.log(this.swiperOptions);
    this.swiperKey += 1
  },
  methods: {
    goToNext() {
      this.$refs.leftSlide.swiper.slideNext();
    },
    goToPrev() {
      this.$refs.leftSlide.swiper.slidePrev();
    },
  },
  data() {
    return {
      swiperKey: 1,
    }
  }
}
</script>

<style scoped lang="less">
.swiper-box {
  width: 3.901709rem;
  // height: .940171rem;
  display: flex;
  position: relative;
  margin: 0 auto;
  top: -.136752rem;
  align-items: center;
  .swiper-container {
    flex: 1;
  }

  .nav-btn {
    width: .119658rem;
    cursor: pointer;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 25px;
    color: #707070;
    img {
      width: 100%;
    }
  }

  .swiper-img {
    width: 100%;
    height: auto;
  }

  .btn-prev {
   margin-right: .08547rem;
  }

  .btn-next {
   margin-left: .08547rem;
  }

  /deep/ .swiper-container {
    width: 3.290598rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/invite/inviteSwiper.vue